// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { isV2 } from '../../../../utils/feature-flag-utils'
import { getServiceDetailsPath } from '../../../../utils/common-utils'

export const usersRedirection = (navigate, path, item) => {
  if (isV2()) {
    navigate(`/manage-account/identity/users/${item?.global_id}`, {
      state: {
        userEmail: item?.email
      }
    })
  } else if (item.user_status === 'UNVERIFIED') {
    navigate('/manage-account/identity/users', {
      state: {
        search_string: item.email
      }
    })
  } else {
    navigate(path)
  }
}

export const serviceRedirection = (navigate, path, item, LDflagValue) => {
  if (!LDflagValue) {
    const detailsPath = getServiceDetailsPath(item?.name)
    navigate(`/services/service-catalog/${detailsPath}`)
  } else {
    navigate(path)
  }
}
